import { GridFilterModel } from '@mui/x-data-grid-premium'
import CustomFiltersModal from 'components/DataGrid/components/CustomFiltersModal'
import CustomStatusFilter from 'components/DataGrid/createColumns/CustomStatusFilter'
import {
  dealStatusFilters,
  dealStageFilters,
  contractStatusFilters,
  dealTypeFilters,
} from 'components/DataGrid/filterArrays'
import CustomFiltersMenu from 'components/ui/custom-filters-menu-button'
import { useState } from 'react'

const DealsFilter = ({
  filterModel,
  onSetFilter,
  isOpen,
  anchorEl,
  onOpenFilters,
  onClose,
}: {
  filterModel: GridFilterModel
  onSetFilter: (_fieldName: string, selectedValues: string[]) => void
  isOpen: boolean
  anchorEl: HTMLElement | null
  onOpenFilters: (event: React.MouseEvent) => void
  onClose: () => void
}) => {
  const [filterStatus, setFilterStatus] = useState<string>('')
  const [filterDealStatus, setFilterDealStatus] = useState<string>('')
  const [filterStage, setFilterStage] = useState<string>('')
  const [typeFilter, setTypeFilter] = useState<string>('')

  return (
    <>
      <CustomFiltersMenu
        onOpenCustomFilters={onOpenFilters}
        count={filterModel?.items?.length ?? 0}
        badgeColor={'icon.deals'}
      />
      <CustomFiltersModal isOpen={isOpen} anchorEl={anchorEl} handleCloseCustomFilters={onClose}>
        <CustomStatusFilter
          context={'dealStatus'}
          options={dealStatusFilters}
          setterFn={setFilterDealStatus}
          filterModel={filterModel}
          value={filterDealStatus}
          onChange={onSetFilter}
        />
        <CustomStatusFilter
          context={'stage'}
          options={dealStageFilters}
          setterFn={setFilterStage}
          filterModel={filterModel}
          value={filterStage}
          onChange={onSetFilter}
        />
        <CustomStatusFilter
          context={'status'}
          options={contractStatusFilters}
          setterFn={setFilterStatus}
          filterModel={filterModel}
          value={filterStatus}
          onChange={onSetFilter}
        />
        <CustomStatusFilter
          context={'type'}
          options={dealTypeFilters}
          setterFn={setTypeFilter}
          filterModel={filterModel}
          value={typeFilter}
          onChange={onSetFilter}
        />
      </CustomFiltersModal>
    </>
  )
}
export default DealsFilter
